/**
 * =========================================================================================
 * ATS - ToolBar
 * =========================================================================================
 * ToolBar
 **/
import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useLocation} from 'react-router-dom';
import * as Icon from 'ubs-icons';
import {COLOR} from "ubs-framework/v2/common/constant";
import {isInApp, isMobileDevice} from "ubs-framework/v2/common/function";
import UPopup from "ubs-framework/v2/UPopup";
import GlobalSearch from "./components/global-search";
import UBadge from "ubs-framework/v2/UBadge";
import NotificationPopupList from "./components/notification-popup-list";
import Popup from "reactjs-popup";
import CandidateFieldsImportExport from "../import-export-data/candidate-fields";
import SetReminder from "../../reminder/components/set-reminder";
import AddInterview from "../../interviews/components/add-interview";
import AddQuickCandidate from "../../candidates/components/add-quick-candidate";
import useSocket from "../hooks/useSocket";
import useImportJobs from "../hooks/useImportJobs";
import {showToastSuccess} from "ubs-framework/v2/common/function";
import usePlan from "../hooks/usePlan";
import {PLAN} from 'ubs-framework/v2/common/constant';
import BulkResumeImportExport from "../import-export-data/bulk-resume";
import DownloadPopupList from "./components/download-popup-list";
import {sendData} from "../../../store/actions";
import UTooltip from "ubs-framework/v2/Utooltip";
const ToolBar = (props) => {
    const __plan = usePlan()
    const popupRef = useRef(null);
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();

    const _ORG_ID = useSelector(e => e.common.orgId);
    const _NC = useSelector(e => e?.ats?.notificationCount);
    const _AQC = useSelector(e => e?.candidate?.addQuickCandidate || {});

    const _UAC_C = useSelector(e => e?.ats?.uac?.candidates?.modules);
    const _UAC_R = useSelector(e => e?.ats?.uac?.requisition?.modules);
    const P_J = useSelector(e => ({
        create: e?.ats?.uac?.jobs?.modules?.jobs?.action?.create?.value,
        import: e?.ats?.uac?.jobs?.modules?.importJobs?.action?.create?.value,
    }));
    const openJobImporter = useImportJobs();
    const P_I = useSelector(e => ({
        create: e?.ats?.uac?.interview?.modules?.interview?.action?.create?.value
    }));
    const P_R = useSelector(e => ({
        create: e?.ats?.uac?.reminder?.modules?.reminder?.action?.create?.value
    }));

    const [interViewFlag, setInterViewFlag] = useState(false);
    const [addFlag, setAddFlag] = useState(false);
    const [currentPath, setCurrentPath] = useState('');
    const [notificationFlag, setNotificationFlag] = useState(false);
    const [isGlobalSearchOpen, setIsGlobalSearchOpen] = useState(false);
    const [importResume, setResumeImport] = useState(false);
    const [candidateImport, setCandidateImport] = useState(false);
    const [openDownloadPopup, setOpenDownloadPopup] = useState(false);
    const [downloadCount, setDownloadCount] = useState(() => { try { return parseInt(localStorage.getItem('download_count')) || 0; } catch (e) { return 0; } });
    const [showDownloadIcon, setShowDownloadIcon] = useState(!!document.cookie.split('; ').find(row => row.startsWith('download_activity=')));

    const splitData = location?.pathname?.split('/');
    
    const [pathArray, setPathArray] = useState([
        {name: 'dashboard', path: ['dashboard']},

        /*****************************************************************************/
        /** Jobs **/
        /*****************************************************************************/
        {name: 'jobs', path: ['jobs']},
        {name: `jobs/${splitData[3]}/${splitData[4]}`, path: [`jobs`, `job details`], previous: 'jobs', route: 'jobs-details'},
        {name: 'jobs/add', path: [`jobs`, `new jobs`], previous: 'goback'},
        {name: `jobs/add/${splitData[4]}`, path: [`jobs`, `new jobs`], previous: 'jobs', route: 'add-jobs'},
        {name: `jobs/edit/${splitData[4]}`, path: [`jobs`, `edit jobs`], previous: 'jobs', route: 'edit-jobs'},

        /*****************************************************************************/
        /** Reminder **/
        /*****************************************************************************/
        {name: 'reminder', path: ['reminder']},

        /*****************************************************************************/
        /** Interview **/
        /*****************************************************************************/
        {name: 'interviews', path: ['interviews']},

        /*****************************************************************************/
        /** Events **/
        /*****************************************************************************/
        {name: 'events', path: ['events']},
        {name: 'events/add', path: [`event`, `Create Event`], previous: 'events'},

        /*****************************************************************************/
        /** Candidate **/
        {name: 'candidates/list', path: ['candidates']},
        {name: 'candidates/blocked-candidates', path: ['Remark Candidates']},
        {name: 'candidates/shared-candidates', path: ['Shared Candidates']},
        {name: 'candidates/verification-candidates', path: ['Verification Candidates']},
        {name: 'candidates', path: ['candidates']},
        {name: 'candidates/add', path: [`candidates`, `new candidates`], previous: 'goback'},
        {name: `candidates/add/${splitData[4]}`, path: [`candidates`, `new candidates`], previous: 'goback', route: 'add-candidates'},
        {name: `candidates/edit/${splitData[4]}`, path: [`candidates`, `edit candidates`], previous: 'candidates/list', route: 'edit-candidates'},
        {name: `candidates/view/${splitData[4]}`, path: [`candidates`, `candidates view`], previous: 'candidates/list', route: 'view-candidates'},
        {name: `candidates/details/${splitData[4]}/${splitData[5]}`, path: [`candidates`, `candidates details`], previous: 'candidates/list', route: 'candidates'},
        /*****************************************************************************/

        /*****************************************************************************/
        /** Preboarding **/
        {name: 'preboarding/kickoff', path: ['preboarding']},
        {name: `preboarding/information-gathering`, path: ['preboarding']},
        {name: `preboarding/information-gathering/${splitData[4]}`, path: ['preboarding', 'information gathering'], previous: 'preboarding/information-gathering', route: "information-gathering-create"},
        {name: `preboarding/information-gathering/upload/${splitData[5]}/${splitData[6]}`, path: ['preboarding', 'information gathering'], previous: 'goback', route: "information-gathering-upload"},
        {name: `preboarding/edit-candidate/${splitData[4]}/${splitData[4]}`, path: ['preboarding', 'Edit Candidate Detail'], previous: 'goback', route: "edit-candidate-info"},
        {name: `preboarding/view-candidate/${splitData[4]}/${splitData[5]}`, path: ['preboarding', 'View Candidate Detail'], previous: 'goback', route: "view-candidate-info"},
        {name: `preboarding/information-gathering/view/${splitData[5]}`, path: ['preboarding', 'information gathering'], previous: 'preboarding/information-gathering', route: "information-gathering-view"},
        {name: `preboarding/information-gathering/edit/${splitData[5]}`, path: ['preboarding', 'information gathering'], previous: 'preboarding/information-gathering', route: "information-gathering-edit"},
        {name: `preboarding/information-gathering/edit-verify/${splitData[5]}`, path: ['preboarding', 'information gathering'], previous: 'preboarding/verify-information', route: "verify-information-edit"},
        {name: `preboarding/information-gathering/edit-release-offer/${splitData[5]}`, path: ['preboarding', 'information gathering'], previous: 'preboarding/information-gathering', route: "information-gathering-edit-release-offer"},
        {name: 'preboarding/verify-information', path: ['preboarding']},
        {name: 'preboarding/release-offer', path: ['preboarding']},
        {name: 'preboarding/offer-acceptance', path: ['preboarding']},
        {name: 'preboarding/hired', path: ['preboarding']},
        {name: `preboarding/kickoff/${splitData[4]}`, path: ['preboarding',`kick off`] , previous: 'preboarding/kickoff' ,route: 'kickoff'},
        {name: `preboarding/document-signature/${splitData[4]}`, path: ['preboarding',`document Signature`], route:"document-signature-detail" },
        {name: `preboarding/document-signature`, path: ['preboarding',`document Signature`] , route:"document-signature-list"},
        {name: `preboarding/offer-letter-approvals`, path: ['preboarding',`offer letter approvals`] , route:"offer-letter-approvals"},
        {name: `preboarding/verify-information/${splitData[4]}`, path: ['preboarding',`verify information`] , previous: 'preboarding/verify-information' ,route: 'verify-information'},
        {name: `preboarding/verify-information/re-verify/${splitData[5]}`, path: ['preboarding',`verify information`] , previous: 'preboarding/verify-information' ,route: 're-verify-information'},
        {name: `preboarding/release-offer/${splitData[4]}`, path: ['preboarding',`release offer`] , previous: 'preboarding/release-offer' ,route: 'release-offer'},
        {name: `preboarding/generate-offer/${splitData[4]}`, path: ['preboarding',`generate offer`] , previous: 'preboarding/release-offer' ,route: 'generate-offer'},
        {name: `preboarding/verify-offer/${splitData[4]}`, path: ['preboarding',`verify offer`] , previous: 'preboarding/release-offer' ,route: 'verify-offer'},
        {name: `preboarding/release-offer/edit/${splitData[5]}`, path: ['preboarding',`release offer`] , previous: 'preboarding/release-offer' ,route: 'release-offer'},
        {name: `preboarding/hired/${splitData[4]}`, path: ['preboarding',`kick off`] , previous: 'preboarding/hired' ,},
        /*****************************************************************************/

        /*****************************************************************************/
        /** Requisitions **/
        /*****************************************************************************/
        {name: 'requisitions', path: ['requisitions']},
        {name: 'requisitions/add', path: [`requisitions`, `new requisitions`], previous: 'goback'},
        {name: `requisitions/edit/${splitData[4]}`, path: [`requisitions`, `edit requisitions`], previous: 'requisitions', route: 'edit-requisitions'},

        /*****************************************************************************/
        /** EmployeeList **/
        /*****************************************************************************/
        {name: 'employee-list', path: ['Employee List']},

        /*****************************************************************************/
        /** Referrals **/
        /*****************************************************************************/
        {name: 'referral', path: [`Referrals`]},
        {name: 'referral/add', path: [`Referrals`, `Referral`], previous: 'goback'},
        {name: `referral/edit/${splitData[4]}`, path: [`Referrals`, `Referral`], previous: 'goback', route: 'referral-edit'},

        /*****************************************************************************/
        /** Settings **/
        /*****************************************************************************/
        {name: 'settings/company-setting', path: [`settings`, `company settings`]},
        // {name: 'settings/general-settings/general-setting', path: [`settings`, `General settings`]},
        {name: 'settings/email-configure', path: [`settings`, `Email Configure`]},
        {name: 'settings/whatsapp-notification', path: [`settings`, `WhatsApp Notifications`]},
        {name: 'settings/org-structure/bands', path: [`settings`, `Org Structure`, 'bands']},
        {name: 'settings/org-structure/grade', path: [`settings`, `Org Structure`, 'grade']},
        {name: 'settings/preboarding-settings/documents', path: [`settings`, `preboarding settings`]},
        {name: 'settings/preboarding-settings/offer-approval', path: [`settings`, `preboarding settings`]},
        {name: 'settings/preboarding-settings/offer-templates', path: [`settings`, `preboarding settings`]},
        {name: `settings/preboarding-settings/information-fields/create`, path: [`preboarding settings`, `Information Field Templates`], route: 'information-fields-create', previous: 'goback'},
        {name: `settings/preboarding-settings/information-fields/edit/${splitData[6]}`, path: [`preboarding settings`, `Information Field Templates`], route: 'information-fields-edit', previous: 'goback'},
        {name: `settings/preboarding-settings/information-fields/view/${splitData[6]}`, path: [`preboarding settings`, `Information Field Templates`], route: 'information-fields-view', previous: 'goback'},
        {name: 'settings/preboarding-settings/information-fields', path: [`settings`, `preboarding settings`]},

        {name: 'settings/preboarding-settings/signature-settings', path: [`settings`, `preboarding settings`]},
        {name: 'settings/notification', path: [`settings`, `notification`]},
        {name: 'settings/integration', path: [`settings`, `integration`]},
        {name: 'settings/access-level', path: [`settings`, `access level`]},
        {name: 'access-level/unassigned-employees', path: [`access level`, `unassigned employees`], previous: 'goback'},
        {name: 'settings/access-level/add', path: [`settings`, `access level`, `new access level`], previous: 'settings/access-level'},
        {
            name: `settings/access-level/edit/${splitData[5]}`,
            path: [`settings`, `access level`, `edit access level`],
            previous: 'settings/access-level',
            route: 'edit-access-level'
        },
        {name: 'settings/audit-logs', path: [`settings`, `Audit Logs`]},
        {name: 'settings/disqualify-reasons', path: [`settings`, `Disqualify Reasons`]},
        {name: 'settings/disqualify-reasons/add', path: [`settings`, `disqualify reasons`, `new disqualify reasons`], previous: 'settings/disqualify-reasons'},
        {
            name: `settings/disqualify-reasons/edit/${splitData[5]}`,
            path: [`settings`, `disqualify reasons`, `edit disqualify reasons`],
            previous: 'settings/disqualify-reasons',
            route: 'edit-disqualify-reasons'
        },
        {name: 'settings/tags-and-sources', path: [`settings`, `Tags and Sources`]},
        {name: 'settings/job-perk', path: [`settings`, `Job Detail and Company Perk`]},
        {name: `settings/pipeline-templates`, path: [`settings`, `Pipeline Templates`]},
        {name: `settings/pipeline-templates/${splitData[4]}`, path: [`settings`, `Pipeline Templates`], route: 'pipeline-templates'},
        {
            name: `settings/pipeline-templates/${splitData[4]}/add`,
            path: [`settings`, `Pipeline Templates`, `Add New Stage`],
            previous: `settings/pipeline-templates/${splitData[4]}`,
            route: 'add-pipeline-templates'
        },
        {
            name: `settings/pipeline-templates/${splitData[4]}/add/${splitData[6]}`,
            path: [`settings`, `Pipeline Templates`, `Add Sub Stage`],
            previous: `settings/pipeline-templates/${splitData[4]}`,
            route: 'sub-add-pipeline-templates'
        },
        {
            name: `settings/pipeline-templates/${splitData[4]}/edit/${splitData[6]}`,
            path: [`settings`, `Pipeline Templates`, `Edit Stage`],
            previous: `settings/pipeline-templates/${splitData[4]}`,
            route: 'edit-pipeline-templates'
        },
        {
            name: `settings/pipeline-templates/${splitData[4]}/edit/${splitData[6]}/${splitData[7]}`,
            path: [`settings`, `Pipeline Templates`, `Edit Sub Stage`],
            previous: `settings/pipeline-templates/${splitData[4]}`,
            route: 'sub-edit-pipeline-templates'
        },
        {name: `settings/interview-form-templates`, path: [`settings`, `Interview Form Templates`], route: 'interview-form-templates'},
        {name: `settings/interview-form-templates/create/blank`, path: [`settings`, `Interview Form Templates`, `Create Template`], previous: 'settings/interview-form-templates', route: 'create-interview-form-template' },
        {name: `settings/interview-form-templates/create/blank/${splitData[6]}`, path: [`settings`, `Interview Form Templates`, `Edit Template`], previous: 'settings/interview-form-templates', route: 'edit-interview-form-template' },
        {name: `settings/interview-form-templates/view/${splitData[5]}`, path: [`settings`, `Interview Form Templates`, `View Template`], previous: 'settings/interview-form-templates', route: 'view-interview-form-template' },
        {name: `settings/custom-fields`, path: [`settings`, `Custom Fields`]},
        {name: `settings/custom-fields/${splitData[4]}`, path: [`settings`, `Custom Fields`], route: 'custom-fields'},
        {name: `settings/question-bank`, path: [`settings`, `Question Bank`]},
        {name: `settings/question-bank/${splitData[4]}`, path: [`settings`, `Question Bank`], route: 'question-bank'},
        {name: `settings/duplicate-handling`, path: [`settings`, `Duplicate Handling`]},
        {name: `settings/email-templates`, path: [`settings`, `Email Templates`]},
        {name: `settings/email-templates/${splitData[4]}`, path: [`settings`, `Email Templates`], route: 'email-templates'},
        {name: `settings/evaluation-forms`, path: [`settings`, `Evaluation Forms`]},
        {name: `settings/evaluation-forms/${splitData[4]}`, path: [`settings`, `Evaluation Forms`], route: 'evaluation-forms'},
        {name: `settings/questionnaires`, path: [`settings`, `Questionnaires`]},
        {name: `settings/questionnaires/${splitData[4]}`, path: [`settings`, `Questionnaires`], route: 'questionnaires'},
        {name: `settings/verification-template`, path: [`settings`, `Verification Template`]},
        {name: `settings/verification-template/${splitData[4]}`, path: [`settings`, `Verification Template`], route: 'verification-template'},
        {name: `settings/screening-questions`, path: [`settings`, `Screening Questions`]},
        {name: `settings/screening-questions/${splitData[4]}`, path: [`settings`, `Screening Questions`], route: 'screening-questions'},
        {name: `settings/event-questions`, path: [`settings`, `Event Questions`]},
        {name: `settings/event-questions/${splitData[4]}`, path: [`settings`, `Event Questions`], route: 'event-questions'},
        {name: 'settings/job-templates', path: [`settings`, `Job Templates`]},
        {name: 'settings/job-id', path: [`settings`, `Job ID`]},
        {name: 'settings/candidate-id', path: [`settings`, `Candidate ID`]},
        {name: 'settings/job-templates/add', path: [`Job Templates`, `Create Job Template`], previous: 'settings/job-templates'},
        {name: `settings/job-templates/add/${splitData[5]}`, path: [`Job Templates`, `Create Job Template`], route: 'add-job-templates', previous: 'settings/job-templates'},
        {name: `settings/preboarding-settings/offer-templates/edit/${splitData[6]}`, path: [`Offer Letter Templates`, `Edit Offer Letter Template`], route: 'edit-offer-templates', previous: 'settings/preboarding-settings/offer-templates/select'},
        {name: `settings/preboarding-settings/offer-templates/add`, path: [`Offer Letter Templates`, `Create Offer Letter Template`], route: 'add-offer-templates', previous: 'settings/preboarding-settings/offer-templates/select'},
        {name: `settings/preboarding-settings/offer-templates/select`, path: [`Offer Letter Templates`, `Select Offer Letter Template`], route: 'select-offer-templates', previous: 'settings/preboarding-settings/offer-templates'},
        {name: `settings/job-templates/edit/${splitData[5]}`, path: [`Job Templates`, `Edit Job Template`], route: 'edit-job-templates', previous: 'settings/job-templates'},
        {name: 'settings/archive-job-candidate', path: [`settings`, `Archive Job/Candidate`]},
        {name: 'settings/job-title', path: [`settings`, `Job Title`]},
        {name: 'settings/interview-type', path: [`settings`, `Interview Type`]},
        {name: 'settings/job-type', path: [`settings`, `Job Type`]},
        {name: 'settings/experience-level', path: [`settings`, `Experience Level`]},
        {name: 'settings/department', path: [`settings`, `Department`]},
        {name: 'settings/location', path: [`settings`, `Location`]},
        {name: 'settings/skill', path: [`settings`, `Skill`]},
        {name: 'settings/degree', path: [`settings`, `Degree`]},
        {name: 'settings/reason-for-job-change', path: [`settings`, `Reason For Job Change`]},
        {name: 'settings/reject-reason', path: [`settings`, `Reject Reason`]},
        {name: 'settings/requisition-type', path: [`settings`, `Requisition Type`]},

        /** Requisitions Setting */
        {name: 'settings/requisitions-setting/requisition-policy', path: [`settings`, `Requisition Policy`]},
        {name: 'settings/requisitions-setting/requisition-policy/add', path: [`Requisition Policy`, `Add Requisition Policy`], previous: 'settings/requisitions-setting/requisition-policy'},
        {name: `settings/requisitions-setting/requisition-policy/edit/${splitData[6]}`, path: [`Requisition Policy`, `Requisition Policy Details`], previous: 'settings/requisitions-setting/requisition-policy', route: 'edit-requisition-policy'},
        {name: 'settings/requisitions-setting/requisition-fields', path: [`settings`, `Requisition Fields`]},

        /** Reports */
        {name: 'reports/job-wise-candidate-report', path: [`reports`, `Job wise candidate report`]},
        {name: `reports/job-wise-candidate-report/${splitData[4]}`, path: [`Job wise candidate report`, `Saved report`], previous: 'reports/job-wise-candidate-report', route: 'job-wise-candidate-report'},
        {name: 'reports/recruiter-wise-candidate-report', path: [`reports`, `Recruiter wise candidate report`]},
        {name: `reports/recruiter-wise-candidate-report/${splitData[4]}`, path: [`Recruiter wise report`, `Saved report`], previous: 'reports/recruiter-wise-candidate-report', route: 'recruiter-wise-candidate-report'},
        {name: 'reports/stage-wise-candidate-report', path: [`reports`, `Stage wise candidate report`]},
        {name: `reports/stage-wise-candidate-report/${splitData[4]}`, path: [`Stage wise candidate report`, `Saved report`], previous: 'reports/stage-wise-candidate-report', route: 'stage-wise-candidate-report'},
        {name: 'reports/disqualify-candidate-report', path: [`reports`, `Disqualify candidate report`]},
        {name: `reports/disqualify-candidate-report/${splitData[4]}`, path: [`Disqualify candidate report`, `Saved report`], previous: 'reports/disqualify-candidate-report', route: 'disqualify-candidate-report'},
        {name: 'reports/source-wise-candidate-report', path: [`reports`, `Source wise candidate report`]},
        {name: `reports/source-wise-candidate-report/${splitData[4]}`, path: [`Source wise candidate report`, `Saved report`], previous: 'reports/source-wise-candidate-report', route: 'source-wise-candidate-report'},
        {name: 'reports/all-jobs-hiring-status-report', path: [`reports`, `All jobs hiring status report`]},
        {name: `reports/all-jobs-hiring-status-report/${splitData[4]}`, path: [`All jobs hiring status report`, `Saved report`], previous: 'reports/all-jobs-hiring-status-report', route: 'all-jobs-hiring-status-report'},
        {name: 'reports/job-wise-interviews-report', path: [`reports`, `Job wise interviews report`]},
        {name: `reports/job-wise-interviews-report/${splitData[4]}`, path: [`Job wise interviews report`, `Saved report`], previous: 'reports/job-wise-interviews-report', route: 'job-wise-interviews-report'},
        {name: 'reports/archived-jobs-report', path: [`reports`, `Archived Jobs Report`]},
        {name: `reports/archived-jobs-report/${splitData[4]}`, path: [`Archived Jobs Report`, `Saved report`], previous: 'reports/archived-jobs-report', route: 'archived-jobs-report'},
        {name: 'reports/archived-candidate-report', path: [`reports`, `Archive-UnArchive Candidate Report`]},
        {name: 'reports/active-candidate-report', path: [`reports`, `Active-Inactive Candidate Report`]},
        {name: 'reports/download-request-report', path: [`reports`, `Download Candidate Report`]},
        {name: 'reports/import-summary-report', path: [`reports`, `Import Summary Report`]},
        {name: `reports/archived-candidate-report/${splitData[4]}`, path: [`Archive-UnArchive Report`, `Saved report`], previous: 'reports/archived-candidate-report', route: 'archived-candidate-report'},
        {name: `reports/active-candidate-report/${splitData[4]}`, path: [`Active-Inactive Report`, `Saved report`], previous: 'reports/active-candidate-report', route: 'active-candidate-report'},
        {name: 'reports/offer-letter-report', path: [`reports`, `Offer Letter Report`]},
        {name: 'reports/time-to-fill-report', path: [`reports`, `Time to Fill report`]},
        {name: 'reports/employee-turnover-rate-report', path: [`reports`, `Employee Turnover Rate report`]},
        {name: 'reports/offer-acceptance-rate-report', path: [`reports`, `Offer Acceptance Rate report`]},
        {name: 'reports/fill-rate-report', path: [`reports`, `Fill Rate report`]},
        {name: 'reports/interview-to-offer-ratio-report', path: [`reports`, `Interview To Offer Ratio report`]},
        {name: 'reports/recruitment-pipeline-status-report', path: [`reports`, `Recruitment Pipeline Status report`]},
        {name: 'reports/rejected-and-hold-candidates-report', path: [`reports`, `Rejected & Hold Candidates report`]},
        {name: 'reports/opening-vs-application-vs-onboarding-report', path: [`reports`, `Opening vs Application vs Onboarding report`]},
        {name: 'reports/offer-released-vs-offer-acceptance-report', path: [`reports`, `Offer Released vs Offer Acceptance report`]},
        {name: 'reports/diversity-hiring-report', path: [`reports`, `Diversity Hiring report`]},
        {name: 'reports/job-wise-vs-status-wise-vs-tag-wise-report', path: [`reports`, `Job Wise vs Status Wise vs Tag Wise report`]},
        {name: 'reports/workforce-forecast-vs-actual-report', path: [`reports`, `Workforce Forecast vs Actual report`]},
        {name: 'reports/budget-forecast-vs-actual-spend-report', path: [`reports`, `Budget Forecast vs Actual Spend report`]},
        {name: 'reports/screening-efficiency-report', path: [`reports`, `Screening Efficiency report`]},
        {name: 'reports/source-wise-conversion-rate-report', path: [`reports`, `Source-wise Conversion Rate report`]},
        {name: 'reports/funnel-of-job-opening-stages-report', path: [`reports`, `Funnel of Job Opening Stages report`]},
        {name: `release-note`, path: [`Release Note`]},
        {name: `downloads`, path: [`Downloads`]},
        {name: `notifications`, path: [`Notifications`]},

    ]);

    // for Employee Profile
    useEffect(() => {
        let path_array = [...pathArray];
        path_array = path_array?.map(path => {
            if (path?.route && path?.route === 'jobs-details') {
                path.name = `jobs/${splitData[3]}/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'add-jobs') {
                path.name = `jobs/add/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'add-candidates') {
                path.name = `candidates/add/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'edit-jobs') {
                path.name = `jobs/edit/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'edit-requisitions') {
                path.name = `requisitions/edit/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'edit-candidates') {
                path.name = `candidates/edit/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'view-candidates') {
                path.name = `candidates/view/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'candidates') {
                path.name = `candidates/details/${splitData[4]}/${splitData[5]}`;
            }
            if (path?.route && path?.route === 'edit-access-level') {
                path.name = `settings/access-level/edit/${splitData[5]}`;
            }
            if (path?.route && path?.route === 'edit-disqualify-reasons') {
                path.name = `settings/disqualify-reasons/edit/${splitData[5]}`;
            }
            if (path?.route && path?.route === 'edit-requisition-policy') {
                path.name = `settings/requisitions-setting/requisition-policy/edit/${splitData[6]}`;
            }
            if (path?.route && path?.route === 'pipeline-templates') {
                path.name = `settings/pipeline-templates/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'add-pipeline-templates') {
                path.name = `settings/pipeline-templates/${splitData[4]}/add`;
                path.previous = `settings/pipeline-templates/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'sub-add-pipeline-templates') {
                path.name = `settings/pipeline-templates/${splitData[4]}/add/${splitData[6]}`;
                path.previous = `settings/pipeline-templates/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'edit-pipeline-templates') {
                path.name = `settings/pipeline-templates/${splitData[4]}/edit/${splitData[6]}`;
                path.previous = `settings/pipeline-templates/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'sub-edit-pipeline-templates') {
                path.name = `settings/pipeline-templates/${splitData[4]}/edit/${splitData[6]}/${splitData[7]}`;
                path.previous = `settings/pipeline-templates/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'interview-form-templates') {
                path.name = `settings/interview-form-templates`;
            }
            if (path?.route && path?.route === 'create-interview-form-template') {
                path.name = `settings/interview-form-templates/create/blank`;
            }
            if (path?.route && path?.route === 'edit-interview-form-template') {
                path.name = `settings/interview-form-templates/create/blank/${splitData[6]}`;
            }
            if (path?.route && path?.route === 'view-interview-form-template') {
                path.name = `settings/interview-form-templates/view/${splitData[5]}`;
            }
            if (path?.route && path?.route === 'custom-fields') {
                path.name = `settings/custom-fields/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'question-bank') {
                path.name = `settings/question-bank/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'email-templates') {
                path.name = `settings/email-templates/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'evaluation-forms') {
                path.name = `settings/evaluation-forms/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'questionnaires') {
                path.name = `settings/questionnaires/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'screening-questions') {
                path.name = `settings/screening-questions/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'verification-template') {
                path.name = `settings/verification-template/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'event-questions') {
                path.name = `settings/event-questions/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'add-job-templates') {
                path.name = `settings/job-templates/add/${splitData[5]}`;
            }
            if (path?.route && path?.route === 'edit-job-templates') {
                path.name = `settings/job-templates/edit/${splitData[5]}`;
            }
            if (path?.route && path?.route === 'edit-offer-templates') {
                path.name = `settings/preboarding-settings/offer-templates/edit/${splitData[6]}`;
            }
            if (path?.route && path?.route === 'add-offer-templates') {
                path.name = `settings/preboarding-settings/offer-templates/add`;
            }
            if (path?.route && path?.route === 'select-offer-templates') {
                path.name = `settings/preboarding-settings/offer-templates/select`;
            }
            if (path?.route && path?.route === 'information-field-view') {
                path.name = `settings/preboarding-settings/information-fields/view/${splitData[6]}`;
            }
            if (path?.route && path?.route === 'information-field-edit') {
                path.name = `settings/preboarding-settings/information-fields/edit/${splitData[6]}`;
            }
            if (path?.route && path?.route === 'information-field-create') {
                path.name = `settings/preboarding-settings/information-fields/create`;
            }
            if (path?.route && path?.route === 'information-field') {
                path.name = `settings/preboarding-settings/information-fields`;
            }
            if (path?.route && path?.route === 'job-wise-candidate-report') {
                path.name = `reports/job-wise-candidate-report/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'recruiter-wise-candidate-report') {
                path.name = `reports/recruiter-wise-candidate-report/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'stage-wise-candidate-report') {
                path.name = `reports/stage-wise-candidate-report/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'disqualify-candidate-report') {
                path.name = `reports/disqualify-candidate-report/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'source-wise-candidate-report') {
                path.name = `reports/source-wise-candidate-report/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'all-jobs-hiring-status-report') {
                path.name = `reports/all-jobs-hiring-status-report/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'job-wise-interviews-report') {
                path.name = `reports/job-wise-interviews-report/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'archived-jobs-report') {
                path.name = `reports/archived-jobs-report/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'archived-candidate-report') {
                path.name = `reports/archived-candidate-report/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'active-candidate-report') {
                path.name = `reports/active-candidate-report/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'information-gathering-create') {
                path.name = `preboarding/information-gathering/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'information-gathering-view') {
                path.name = `preboarding/information-gathering/view/${splitData[5]}`;
            }
            if (path?.route && path?.route === 'information-gathering-upload') {
                path.name = `preboarding/information-gathering/upload/${splitData[5]}/${splitData[6]}`;
            }
            if (path?.route && path?.route === 'edit-candidate-info') {
                path.name = `preboarding/edit-candidate/${splitData[4]}/${splitData[5]}`;
            }
            if (path?.route && path?.route === 'view-candidate-info') {
                path.name = `preboarding/view-candidate/${splitData[4]}/${splitData[5]}`;
            }
            if (path?.route && path?.route === 'information-gathering-edit') {
                path.name = `preboarding/information-gathering/edit/${splitData[5]}`;
            }
            if (path?.route && path?.route === 'verify-information-edit') {
                path.name = `preboarding/information-gathering/edit-verify/${splitData[5]}`;
            }
            if (path?.route && path?.route === 'information-gathering-edit-release-offer') {
                path.name = `preboarding/information-gathering/edit-release-offer/${splitData[5]}`;
            }
            if (path?.route && path?.route === 'verify-information') {
                path.name = `preboarding/verify-information/${splitData[4]}`;
            }
            if (path?.route && path?.route === 're-verify-information') {
                path.name = `preboarding/verify-information/re-verify/${splitData[5]}`;
            }
            if (path?.route && path?.route === 'verify-offer') {
                path.name = `preboarding/verify-offer/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'release-offer') {
                if(Boolean(splitData[5]))  path.name = path.name = `preboarding/release-offer/edit/${splitData[5]}`;
                else  path.name = path.name = `preboarding/release-offer/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'generate-offer') {
                path.name = `preboarding/generate-offer/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'document-signature-detail') {
                path.name = `preboarding/document-signature/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'document-signature-list') {
                path.name = `preboarding/document-signature`;
            }
            if (path?.route && path?.route === 'time-to-fill-report') {
                path.name = `reports/time-to-fill-report/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'employee-turnover-rate-report') {
                path.name = `reports/employee-turnover-rate-report/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'offer-acceptance-rate-report') {
                path.name = `reports/offer-acceptance-rate-report/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'fill-rate-report') {
                path.name = `reports/fill-rate-report/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'interview-to-offer-ratio-report') {
                path.name = `reports/interview-to-offer-ratio-report/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'recruitment-pipeline-status-report') {
                path.name = `reports/recruitment_pipeline-status-report/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'rejected-and-hold-candidates-report') {
                path.name = `reports/rejected-and-hold-candidates-report/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'opening-vs-application-vs-onboarding-report') {
                path.name = `reports/opening-vs-application-vs-onboarding-report/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'offer-released-vs-offer-acceptance-report') {
                path.name = `reports/offer-released-vs-offer-acceptance-report/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'diversity-hiring-report') {
                path.name = `reports/diversity-hiring-report/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'job-wise-vs-status-wise-vs-tag-wise-report') {
                path.name = `reports/job-wise-vs-status-wise-vs-tag-wise-report/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'workforce-forecast-vs-actual-report') {
                path.name = `reports/workforce-forecast-vs-actual-report/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'budget-forecast-vs-actual-spend-report') {
                path.name = `reports/budget-forecast-vs-actual-spend-report/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'screening-efficiency-report') {
                path.name = `reports/screening-efficiency-report/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'source-wise-conversion-rate-report') {
                path.name = `reports/source-wise-conversion-rate-report/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'funnel-of-job-opening-stages-report') {
                path.name = `reports/funnel-of-job-opening-stages-report/${splitData[4]}`;
            }
            if (path?.route && path?.route === 'referral-edit') {
                path.name = `referral/edit/${splitData[4]}`;
            }
            return path;
        });

        setPathArray(path_array);
    }, [location]);

    // Set Current path
    useEffect(() => {
        let path = location?.pathname?.slice(1);
        path = path?.slice(path.indexOf("/") + 1);
        setCurrentPath(pathArray?.find(_ => path === _.name));
    }, [location, pathArray]);

    const {off, refresh} = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'ats|candidate|quick-add': {
                    dispatch({type: 'ADD_QUICK_CANDIDATE', payload: {flag: false, data: {}}});
                    showToastSuccess('Candidate Added Successfully.')
                    break
                }
                default:
                    return true;
            }
        }
    });

    useEffect(() => {
        refresh();
        return () => off();
    }, []);

    // Redirect to previos page
    const redirectPrevious = (path) => {
        if (path?.previous === 'goback') {
            history?.goBack();
        } else {
            history.push(`/${_ORG_ID}/${currentPath?.previous}`);
        }
    }

    const getSidebar = () => {
        dispatch({type: 'OPEN_SIDEBAR', payload: true});
    }

    const handle = {
        toggleSearchBar: (flag) => {
            setIsGlobalSearchOpen(flag);
        }
    }

    const refreshList = () => {
        window.location.reload()
    }

    const redirect = (flag) => {
        if (popupRef?.current) popupRef?.current?.close()
        if (flag === 'candidate') history.push(`/${_ORG_ID}/candidates/add`);
        if (flag === 'quickCandidate') dispatch({type: 'ADD_QUICK_CANDIDATE', payload: {flag: true, data: {}}});
        if (flag === 'requisition') history.push(`/${_ORG_ID}/requisitions/add`);
        if (flag === 'jobs') history.push(`/${_ORG_ID}/jobs/add`);
        if (flag === 'reminder') setAddFlag(true)
        if (flag === 'interview') setInterViewFlag(true)
    }

    const getDownloadList = () => {
        setOpenDownloadPopup(true);
        setDownloadCount(0);
        try { localStorage.removeItem('download_count'); } catch (e) { }
        sendData('hrms|reports|logs|list', {
            limit: 20,
            currentPage: 1,
            filter: { user: [_ID], productType: 3 }
        });
    }

    const importData = (flag) => {
        if (popupRef?.current) popupRef?.current?.close()
        if (flag === 'candidate') setCandidateImport(true)
        if (flag === 'resume') setResumeImport(true)
    }

    return (
        <React.Fragment>
            <div className={`u_project-header u_flex u_align-center u_content-between`} id="u_project-header">
                <div className="u_header-breadcrumb-wpr u_flex u_align-center">

                    {/** Mobile Toggle **/}
                    <button className="u_hrms-sidebar-toggle" onClick={getSidebar}>
                        <span/>
                    </button>

                    {/* Sidebar collapse / expand */}
                    {props?.onToggleSidebar && (
                        <UPopup
                            params={{className: "u_tooltip", disabled: isMobileDevice()}}
                            desc={<span>{props?.sidebarCollapsed ? 'Expand menu' : 'Collapse menu'}</span>}
                        >
                            <button
                                type="button"
                                className={`u_sidebar-collapse-btn ${props?.sidebarCollapsed ? 'u_sidebar-collapse-btn__flip' : ''}`}
                                onClick={props.onToggleSidebar}
                                aria-label={props?.sidebarCollapsed ? 'Expand menu' : 'Collapse menu'}
                                aria-expanded={!props?.sidebarCollapsed}
                            >
                                <Icon.SidebarCollapse size={17} stroke={COLOR?.u_icon_bg}/>
                            </button>
                        </UPopup>
                    )}

                    {/** Breadcrumbs **/}
                    <div className="u_flex u_align-center u_header-breadcrumb">
                        {
                            currentPath?.previous &&
                            <span className="u_icon-rollover u_header-breadcrumb-arrow u_mr-10 u_cp" onClick={() => redirectPrevious(currentPath)}>
                                <Icon.RightArrow size={16} fill={COLOR.u_blue}/>
                            </span>
                        }
                        <ul className="u_flex u_align-center u_flex-shrink">
                            {
                                currentPath?.path?.map((path, i) => {
                                    return <React.Fragment key={i}>
                                        {
                                            !path.includes('undefined') &&
                                            <li className={`${!currentPath?.previous ? 'u_py-5' : ''}`} onClick={() => currentPath?.previous ? redirectPrevious(currentPath) : ''}>
                                                {
                                                    path?.length > 30 ? <UPopup
                                                            params={{className: "u_tooltip", offsetX: 10}}
                                                            desc={<span>{path}</span>}
                                                        >
                                                            <span className="u_one-line">{path}</span>
                                                        </UPopup>
                                                        : `${path}`
                                                }
                                            </li>
                                        }
                                    </React.Fragment>
                                })
                            }
                        </ul>
                    </div>
                </div>

                {/** Global Search **/}
                <GlobalSearch open={isGlobalSearchOpen} closeSidebar={(data) => handle.toggleSearchBar(data)}/>

                {/** Menu Options **/}
                <div className="u_header-options u_flex u_align-center u_content-end">
                    <div className="u_flex u_align-center u_project-menuicon">
                        <div className="u_project-menuicon-inner u_global-search-input__mobile">
                            {/** Global Search Icon **/}
                            <span className="u_cp" onClick={() => handle.toggleSearchBar(true)}>
                                <Icon.Search size={18} fill={COLOR?.u_icon_bg}/>
                            </span>
                        </div>

                        {showDownloadIcon && (
                            <div className="u_project-menuicon-inner">
                                <div className="u_cp" onClick={getDownloadList}>
                                    <div className="u_relative">
                                        {downloadCount !== 0 && <div className="u_notification-badge"><UBadge count={downloadCount >= 100 ? '99+' : downloadCount}/></div>}
                                        <UTooltip
                                            text="Recently Downloads"
                                            on={(open) => (
                                                <span className='u_plain-icon u_cp'>
                                                    <Icon.FileDown color={COLOR.u_icon_bg} size={21}/>
                                                </span>
                                            )}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {(_UAC_C?.candidates?.action?.create?.value || _UAC_R?.requisition?.action?.create?.value) &&
                        <div className="u_project-menuicon-inner">
                            <Popup
                                ref={popupRef}
                                trigger={open => (
                                    <div className="u_filter">
                                        <UPopup params={{className: "u_tooltip"}} desc={<span>Quick Action</span>}>
                                            <span className={`u_flex ${splitData[3] === 'add-new-employee' ? 'u_event-none' : 'u_cp'}`}>
                                                <Icon.UserAdd fill={COLOR.u_icon_bg} size={20}/>
                                            </span>
                                        </UPopup>
                                    </div>
                                )}
                                position="bottom right"
                                closeOnDocumentClick
                                on={['click']}
                                closeOnEscape
                                className="u_popover-container"
                                arrow={false}
                            >
                                <div className="u_popover">
                                    <ul className="u_more-member-popover">
                                        {_UAC_C?.candidates?.action?.create?.value && <li className="u_rollover-text u_rollover u_cp u_flex u_align-center" onClick={() => redirect('candidate')}><p>Add Candidate</p></li>}
                                        {_UAC_C?.candidates?.action?.create?.value && <li className="u_rollover-text u_rollover u_cp u_flex u_align-center" onClick={() => redirect('quickCandidate')}><p>Add Quick Candidate</p></li>}
                                        {__plan(PLAN?.requisitions) && _UAC_R?.requisition?.action?.create?.value && <li className="u_rollover-text u_rollover u_cp u_flex u_align-center" onClick={() => redirect('requisition')}><p>Add Requisitions</p></li>}
                                        {P_J?.create && <li className="u_rollover-text u_rollover u_cp u_flex u_align-center" onClick={() => redirect('jobs')}><p>Add Job</p></li>}
                                        {__plan(PLAN?.reminder) && P_R?.create && <li className="u_rollover-text u_rollover u_cp u_flex u_align-center" onClick={() => redirect('reminder')}><p>Add Reminder</p></li>}
                                        {__plan(PLAN?.interview) && P_I?.create && <li className="u_rollover-text u_rollover u_cp u_flex u_align-center" onClick={() => redirect('interview')}><p>Add Interview</p></li>}
                                        {_UAC_C?.candidates?.action?.create?.value && <li className="u_rollover-text u_rollover u_cp u_flex u_align-center" onClick={() => importData('candidate')}><p>Import Candidate</p></li>}
                                        {_UAC_C?.candidates?.action?.create?.value && <li className="u_rollover-text u_rollover u_cp u_flex u_align-center" onClick={() => importData('resume')}><p>Import Bulk Resume</p></li>}
                                        {P_J?.import && <li className="u_rollover-text u_rollover u_cp u_flex u_align-center" onClick={() => {
                                            if (popupRef?.current) popupRef?.current?.close();
                                            openJobImporter();
                                        }}><p>Import Job</p></li>}
                                    </ul>
                                </div>
                            </Popup>
                        </div>}

                        {/** Notification Icon **/}
                        <div className="u_project-menuicon-inner">
                            <div className="u_cp" onClick={e => setNotificationFlag(true)}>
                                <div className="u_relative">
                                    {_NC !== 0 && <div className="u_notification-badge"><UBadge count={_NC >= 100 ? '99+' : _NC}/></div>}
                                    <UPopup params={{className: "u_tooltip"}} desc={<span>Notifications</span>}>
                                        <span className='u_plain-icon u_cp'>
                                            <Icon.Notifications fill="#4E525F" size={21}/>
                                        </span>
                                    </UPopup>
                                </div>
                            </div>
                            {notificationFlag && <NotificationPopupList openNotification={notificationFlag} setOpenNotification={setNotificationFlag}/>}
                        </div>

                        {isInApp() && <div className="u_project-menuicon-inner">
                            <UPopup params={{className: "u_tooltip"}} desc={<span>Refresh List</span>}>
                                <span className="u_icon-rollover u_cp" onClick={() => refreshList()}>
                                    <Icon.Reload fill="#007AFF" size={18}/>
                                </span>
                            </UPopup>
                        </div>}

                    </div>
                </div>
            </div>

            {/** Reminder Popup */}
            {addFlag && <SetReminder close={() => setAddFlag(false)}/>}

            {/** Reminder Popup */}
            {interViewFlag && <AddInterview close={() => setInterViewFlag(false)}/>}

            {/** Employee fields import Export */}
            {
                candidateImport && <CandidateFieldsImportExport
                    open={candidateImport}
                    header={'Import Candidate Data'}
                    onClose={() => setCandidateImport(false)}
                />
            }

            {
                importResume && <BulkResumeImportExport
                    open={importResume}
                    header={'Import Resume Upload'}
                    onClose={() => setResumeImport(false)}
                />
            }

            {/** Add Quick Candidate */}
            {_AQC?.flag && <AddQuickCandidate/>}

            <DownloadPopupList
                openDownloadPopup={openDownloadPopup}
                setOpenDownloadPopup={setOpenDownloadPopup}
                setShowDownloadIcon={setShowDownloadIcon}
                setDownloadCount={setDownloadCount}
                downloadCount={downloadCount}
            />
        </React.Fragment>
    );
}

export default ToolBar;
